<template>
  <div id="head-bar">
    <div class="navbar-custom">
      <div class="container-fluid">
        <ul class="list-unstyled topnav-menu float-right mb-0">
          <el-menu
            :default-active="activeIndex"
            class="el-menu-demo"
            mode="horizontal"
            menu-trigger="click"
            text-color="#6c757d"
            active-text-color="#6c757d"
            @select="handleSelect"
          >
            <el-submenu index="1" :popper-append-to-body="false">
              <template slot="title">
                <img :src="userInfo.avatar" alt="user-image" class="user-image rounded-circle" />
                {{ userInfo.username }}【{{ userRoleName }}】
              </template>
              <div class="top-tips">
                <span class="text-overflow m-0">切换角色</span>
              </div>
              <el-menu-item
                v-for="(item, index) in canUseRole"
                :key="item.id"
                href="javascript:void(0);"
                :class="item.roleClass"
                @click="setRoleApi(item.id)"
                :index="'1-' + index"
              >
                {{ item.name }}
              </el-menu-item>
            </el-submenu>
            <el-menu-item index="2" @click="logout">
              <i class="fe-log-out"></i>
              <span class="logout-text">退出登录</span>
            </el-menu-item>
          </el-menu>
        </ul>

        <!-- LOGO -->
        <div class="logo-box">
          <a href="index.html" class="logo logo-light text-center">
            <span class="logo-sm">
              <img
                class="logo-img"
                :src="
                  curEnv === 'sysu'
                    ? require('@/assets/images/header_logo_sysu@1x.png')
                    : require('@/assets/images/header_logo.png')
                "
                alt=""
                height="20"
              />
              <span v-if="curEnv === 'sysu'" class="logo-title">数据统计系统</span>
              <span v-else class="logo-title">云课堂数据统计</span>
            </span>
            <span class="logo-lg">
              <img class="logo-img" :src="logoSrc" alt="" height="28" />
              <span class="logo-title">{{ logoTitle }}</span>
            </span>
          </a>
        </div>

        <ul class="list-unstyled topnav-menu topnav-menu-left m-0">
          <li>
            <button class="button-menu-mobile waves-effect waves-light">
              <i class="fe-menu"></i>
            </button>
          </li>

          <li>
            <a
              class="navbar-toggle nav-link"
              data-toggle="collapse"
              data-target="#topnav-menu-content"
            >
              <div class="lines">
                <span></span>
                <span></span>
                <span></span>
              </div>
            </a>
          </li>

          <li class="dropdown d-xl-block">
            <a
              id="nav-platform"
              class="nav-link dropdown-toggle waves-effect waves-light"
              data-toggle="dropdown"
              href="javascript:void(0)"
              role="button"
              aria-haspopup="false"
              aria-expanded="false"
              @click="plateform"
            >
              <i class="mdi mdi-monitor md-24"></i>
              <span class="nav-title">平台</span>
            </a>
            <!-- <div class="dropdown-menu"></div> -->
          </li>
          <li class="dropdown d-xl-block">
            <a
              id="nav-term"
              class="nav-link dropdown-toggle waves-effect waves-light"
              data-toggle="dropdown"
              href="javascript:void(0)"
              role="button"
              aria-haspopup="false"
              aria-expanded="false"
              @click="term"
            >
              <i class="mdi mdi-book"></i>
              <span class="nav-title">学期</span>
            </a>
            <!-- <div class="dropdown-menu"></div> -->
          </li>
          <li class="dropdown d-xl-block">
            <a
              id="nav-course"
              class="nav-link dropdown-toggle waves-effect waves-light"
              data-toggle="dropdown"
              href="javascript:void(0)"
              role="button"
              aria-haspopup="false"
              aria-expanded="false"
              @click="course"
            >
              <i class="mdi mdi-book-open-variant"></i>
              <span class="nav-title">课程</span>
            </a>
            <!-- <div class="dropdown-menu"></div> -->
          </li>

          <li class="dropdown d-xl-block" v-if="![5, 6, 7].includes(userInfo.role_id)">
            <a
              id="nav-supervision"
              class="nav-link dropdown-toggle waves-effect waves-light"
              data-toggle="dropdown"
              href="javascript:void(0)"
              role="button"
              aria-haspopup="false"
              aria-expanded="false"
              @click="supervision"
            >
              <i class="mdi mdi-file-search"></i>
              <span class="nav-title">督导</span>
            </a>
            <!-- <div class="dropdown-menu"></div> -->
          </li>
        </ul>
        <div class="clearfix"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { loginAddress } from '@/config/index.js'
import { mapState } from 'vuex'

export default {
  name: 'HeadBar',
  inject: ['reload'],
  data() {
    return {
      activeIndex: '1',
    }
  },
  computed: {
    ...mapState({
      userInfo(state) {
        return state.commom.userInfo
      },
      roleList(state) {
        return state.commom.roleList
      },
      routesStartPath() {
        console.log('this.$route.path', this.$route.path)
        return this.$route.path
      },
    }),
    canUseRole() {
      let canUseRole = this.roleList.map(item => {
        let roleClass = 'el-menu-item set-role-name'
        if (item.id === this.userInfo.role_id) roleClass = 'el-menu-item cur-role-name'
        return {
          roleClass: roleClass,
          ...item,
        }
      })
      return canUseRole
    },
    userRoleName() {
      let curRoleName = ''
      for (let i of this.roleList) {
        if (this.userInfo.role_id === i.id) curRoleName = i.name
      }
      return curRoleName
    },
    curEnv() {
      console.log(process.env.VUE_APP_MODE)
      return process.env.VUE_APP_MODE
    },
    logoSrc() {
      // 默认
      let imgSrc = require('@/assets/images/header_logo.png')
      switch (process.env.VUE_APP_MODE) {
        // 中大
        case 'sysu':
          imgSrc = require('@/assets/images/header_logo_sysu@1x.png')
          break
        // 南方医统计
        case 'nfyku':
          imgSrc = require('@/assets/images/header_logo_nfyku.png')
          break
      }
      return imgSrc
    },
    logoTitle() {
      // 默认
      let title = '云课堂数据统计'
      switch (process.env.VUE_APP_MODE) {
        // 中大
        case 'sysu':
          title = '数据统计系统'
          break
        // 南方医统计
        case 'nfyku':
          title = '数据统计'
          break
      }
      return title
    },
  },
  mounted() {},
  methods: {
    handleSelect(key, keyPath) {
      console.log(key, keyPath)
    },
    refresh() {
      this.reload()
    },
    plateform() {
      document.getElementById('nav-platform').classList.add('active')
      this.$router.push({
        path: '/index',
      })
    },
    course() {
      this.$router.push({
        path: '/course',
      })
    },
    term() {
      this.$router.push({
        path: '/term',
      })
    },
    supervision() {
      this.$router.push({
        path: '/supervision',
      })
    },
    async getUserInfoApi() {
      await this.$store
        .dispatch('commom/getUserInfo')
        .then(res => {
          console.log('res:', res)
          if (res.code === 1) {
            this.$store.commit('commom/setUserInfo', res.data)
          }
        })
        .catch(err => {
          console.log('err:', err)
        })
    },
    async setRoleApi(roleId) {
      await this.$store
        .dispatch('commom/setRole', {
          role_id: roleId,
        })
        .then(res => {
          console.log('res:', res)
          if (res.code === 1) {
            new Promise((resolve, reject) => {
              this.getUserInfoApi()
                .then(() => {
                  if (this.routesStartPath.includes('/courseDetail/myDoc')) {
                    this.$router.push({
                      path: '/courseDetail/baseInfo',
                      query: {
                        courseId: this.$route.query.courseId,
                      },
                    })
                  } else if (
                    this.userInfo.role_id === 6 &&
                    this.routesStartPath.includes('/courseDetail/')
                  ) {
                    this.$router.push({
                      path: '/courseDetail/myDoc',
                      query: {
                        courseId: this.$route.query.courseId,
                        userId: this.userInfo.mdl_userid,
                      },
                    })
                  } else {
                    this.refresh()
                  }
                  this.$nextTick(function () {
                    this.$message.success('设置成功')
                  })
                  resolve()
                })
                .catch(error => {
                  reject(error)
                })
            })
          }
        })
        .catch(err => {
          console.log('err:', err)
        })
    },
    async logout() {
      await this.$store
        .dispatch('commom/logout')
        .then(res => {
          this.$store.commit('commom/setToken', '')
          console.log('res:', res)
          window.location.href = loginAddress
        })
        .catch(err => {
          console.log('err:', err)
        })
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .el-submenu.is-opened {
    background-color: #f3f7f9;
  }
  .el-menu.el-menu--horizontal {
    border: none;
    .el-submenu.is-active {
      .el-submenu__title {
        border-bottom: none !important;
      }
    }
  }
  .el-menu {
    margin-top: 0px !important;
  }
  .el-menu--horizontal {
    font-size: 16px;
    color: #6c757d;
    // .el-menu.el-menu--popup.el-menu--popup-bottom-start {
    //   line-height: 70px;
    //   font-size: 16px;
    //   color: #6c757d;
    // }
    .el-menu-item.is-active {
      border-bottom: none !important;
      border-bottom-color: #ffffff !important;
    }
    .el-menu-item {
      line-height: 70px;
      font-size: 16px;
      color: #6c757d;
    }
    .el-submenu {
      .el-submenu__title {
        line-height: 70px;
        height: 70px;
        font-size: 16px;
        color: #6c757d;
        &:hover {
          background-color: unset;
        }
      }
    }
  }
  .el-menu--horizontal[x-placement='bottom-start'] {
    .el-menu--popup-bottom-start {
      margin-top: 1px;
      margin-left: 33px;
      border-radius: 4px;
    }
  }
}
.user-image {
  height: 32px;
  width: 32px;
  margin-right: 6px;
}
.dropdown.notification-list.topbar-dropdown.show {
  background: #f3f7f9;
}
.list-unstyled {
  font-size: 16px;
}
.logo-img {
  margin-top: -7px;
}
.top-tips {
  padding: 7px 20px;
  span {
    font-size: 10px !important;
    height: 10px !important;
    color: #6c757d;
  }
}
.cur-role-name {
  font-size: 14px !important;
  padding: 7px 20px !important;
  color: #3294f6 !important;
  line-height: 21px !important;
  pointer-events: none;
}
.set-role-name {
  font-size: 14px !important;
  padding: 7px 20px !important;
  color: #6c757d !important;
  line-height: 21px !important;
}
.set-role-name:hover {
  background: #f3f7f9 !important;
  color: #272e37 !important;
}

.logo-title {
  margin-left: 8px;
  font-size: 20px;
  font-weight: bold;
  color: #3c4854;
}
.logout-box {
  top: 0.5px;
  line-height: 70px;
  max-height: 70px;
  .dropdown-item {
    padding: 0 1.2rem;
  }
}
.nav-title {
  margin-left: 10px;
  font-size: 16px;
  color: #6c757d;
}
.d-xl-block {
  // margin-right: 22px;
  a.active {
    background: #f3f7f9;
  }
}
.logo-sm {
  white-space: nowrap;
}
.fe-log-out {
  display: none;
  line-height: 70px;
}

@media screen and (max-width: 991.98px) {
  .container-fluid {
    padding-left: 22px;
  }
  .d-xl-block {
    margin-right: 0;
    .nav-link {
      padding: 0 7px;
    }
  }
  .nav-title {
    margin-left: 0;
  }
}

@media screen and (max-width: 870px) {
  .d-xl-block {
    margin-right: 0;
    .nav-link {
      padding: 0 5px;
      .mdi {
        display: none;
      }
    }
  }
  .fe-log-out {
    display: block;
  }
  .logout-text {
    display: none;
  }
}
@media screen and (max-width: 600px) {
  .nav-link {
    padding-left: 0;
    .mdi {
      display: block !important;
    }
  }
  .nav-title {
    margin-left: 3px;
    display: none;
  }
}
</style>
